module.exports = __webpack_public_path__ + "static/img/3980_phase_function_Paper_Points.d4e8904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3980_phase_function_Paper_Points.png
// module id = SIfo
// module chunks = 0